import React, {useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import Table from 'components/UserTable';
import accountTableConfig from './admin-people-table-config';
import {writesAccountRoles} from './accountRoles';

export default ({
  team,
  index,
  createUpdateItem,
  getItems,
  targetRole,
  createUpdateStatus,
}) => {
  const [items, setItems] = useState([]);
  const [contextData, setContextData] = useState({});
  const available = useSelector((state) => state.team.peopleAvailableRoles);
  const tableData = useMemo(
    () => ({
      ...accountTableConfig,
      canSave: (account) =>
        !writesAccountRoles(account) ||
        ((account._id !== 'new_user' || account.accountRoles?.length > 0) &&
          account.accountRoles?.every(
            (role) =>
              available?.includes(role) ||
              account.expectedAccountRoles?.includes(role)
          )),
    }),
    [available]
  );

  useEffect(() => {
    setItems(team.users?.length ? team.users : [tableData.initialRow(team)]);
  }, [team.users]);

  const setInitalItemProps = (id) => ({
    password: '',
    firstName: '',
    lastName: '',
    email: '',
    status: true,
    roles: [],
    accountRoles: [],
    avatar: undefined,
    teamName: team.name,
    teamId: team._id,
    userId: undefined,
    teamOrder: contextData.index + 1,
    _id: id,
    location: '',
  });

  const moveUp = (event) => {
    let item = items[contextData.index];
    item = {
      userId: item._id,
      teamId: team._id,
      teamOrder: contextData.index - 1,
    };
    console.log(item);
    createUpdateItem(item);
    setTimeout(() => {
      getItems();
    }, 1000);
  };

  const moveDown = (event) => {
    let item = items[contextData.index];
    item = {
      userId: item._id,
      teamId: team._id,
      teamOrder: contextData.index + 1,
    };
    console.log(item);
    createUpdateItem(item);
    setTimeout(() => {
      getItems();
    }, 1000);
  };

  return (
    <Table
      team={team}
      index={index}
      tableData={tableData}
      items={items}
      setItems={setItems}
      createUpdateItem={createUpdateItem}
      getItems={getItems}
      setInitalItemProps={setInitalItemProps}
      setContextData={setContextData}
      contextData={contextData}
      menuId={`ADMIN_MENU_${index}`}
      targetRole={targetRole}
      moveUp={moveUp}
      moveDown={moveDown}
      createUpdateStatus={createUpdateStatus}
    />
  );
};
